import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { TournamentBrandingProvider } from './TournamentBrandingContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <TournamentBrandingProvider>
    <App />
  </TournamentBrandingProvider>
);